import { FaDraftingCompass, FaPencilRuler } from 'react-icons/fa';
import { v4 as uuidv4 } from 'uuid';
import thumb1 from '../../assets/img/certi1.webp';
import thumb2 from '../../assets/img/certi2.webp';

const approchData = [
    {
        id: uuidv4(),
        thumb: thumb1,
        icon: <FaDraftingCompass />,
        heading: 'Turbo One Pte Ltd',
        pageLink: '/project-details',
    },

    {
        id: uuidv4(),
        thumb: thumb2,
        icon: <FaPencilRuler />,
        heading: 'Japan FUSA Co., Ltd. - MAGURO',
        pageLink: '/project-details',
    },
];

export default approchData;